import allSettings from "../data/accountSettingsData";
import moment from 'moment'

export default function SimpleShortDate(date) {
    return moment(date).format('Do MMM YYYY')
}